module.exports = __webpack_public_path__ + "img/p-10-4.ccc8762f.png";